import { useLocation } from "react-router-dom";

const items = [
  { id: "home", title: "Home", link: "/" },
  { id: "blog", title: "Blog", link: "/blog" },
];

export default function Navbar() {
  const { pathname } = useLocation();

  return (
    <nav className="flex gap-4 justify-center items-center">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center space-x-8">
          {items.map((item, index) => (
            <a
              key={index}
              href={item.link}
              className={`text-lg font-black uppercase tracking-wide transition-all ${
                pathname === item.link || pathname.startsWith(item.link + "/")
                  ? "border-b-3 border-orange-600 text-orange-600"
                  : "border-b-3 border-transparent hover:border-black"
              }`}
            >
              {item.title}
            </a>
          ))}
        </div>
      </div>
    </nav>
  );
}
